import {z} from 'zod';

import {useHelpLinks} from '../../provider/help-links/help-links-hook';
import {ShortLocaleNameEnum} from '../../provider/locale/locale-context-type';
import {useLocale} from '../../provider/locale/locale-hook';

const MAINTENANCE_BANNER_HELP_LINK_KEY = '^maintenance-banner$';

const maintenanceBannerConfigSchema = z.object({
    show: z.boolean(),
    // Texts keyed by short locale name, e.g. {"ru": "...", "en": "..."}.
    message: z.record(z.string(), z.string()),
});

type MaintenanceBannerStateType = {
    isVisible: boolean;
    message: string | null;
};

export function useMaintenanceBanner(): MaintenanceBannerStateType {
    const helpLinks = useHelpLinks();
    const {shortLocaleName} = useLocale();

    const bannerLink = helpLinks.find((link) => link.urlPattern === MAINTENANCE_BANNER_HELP_LINK_KEY);

    if (!bannerLink) {
        return {isVisible: false, message: null};
    }

    const configResult = maintenanceBannerConfigSchema.safeParse(bannerLink.config);

    if (!configResult.success) {
        return {isVisible: false, message: null};
    }

    const {show, message} = configResult.data;
    // Prefer the user's own language, fall back to English so a maintenance warning is never silently dropped.
    const localizedMessage = message[shortLocaleName] || message[ShortLocaleNameEnum.en] || null;

    if (!show || !localizedMessage) {
        return {isVisible: false, message: null};
    }

    return {isVisible: true, message: localizedMessage};
}
